import { render, staticRenderFns } from "./add-form.vue?vue&type=template&id=4f857f5a&scoped=true"
import script from "./add-form.vue?vue&type=script&setup=true&lang=js"
export * from "./add-form.vue?vue&type=script&setup=true&lang=js"
import style0 from "./add-form.vue?vue&type=style&index=0&id=4f857f5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../erp_vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f857f5a",
  null
  
)

export default component.exports